<!-- 劳务公司的函询 -->
<template>
  <div class="button">
    <div @click.stop="inByLetDialogClick(item)">
      <img style="width:20px;height:20px" src="@/assets/hideBox/hanxun.png" alt />
      <span>函询</span>
    </div>
    <!-- 函询弹框 -->
    <InByLetDialogs
      ref="InBylet"
      :dialogType="1"
      :siteType="siteType"
      @closeDialog="closeinDialog"
      @confirmDialog="confirminDialog"
      :dialogVisible="inByLetDialogShow"
      :inquiryType="inquiryType"
    ></InByLetDialogs>
  </div>
</template>

<script>
import {apiLaborServiceCompany} from "@/api/apiLaborServiceCompany"
import InByLetDialogs from "@/components/public/InquiryLetterLabor";
export default {
  name: "mail",
  inject: ["cardListCom"],
  props: {
    item: Object,
    type: {
      type: [Number, String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  components: {
    InByLetDialogs
  },
  data() {
    return {
      inByLetDialogShow: false,
      siteType:this.$store.state.user.type,
      inquiryType: [],
    }
  },
  methods: {
    //点击函询按钮
    async inByLetDialogClick(item) {
      if (this.permissionTips()) return
      this.getInquiryType()
      this.inByLetDialogShow = true
    },
    // 函询关闭
    closeinDialog(val) {
      this.inByLetDialogShow = val;
      this.$refs.InBylet.clearForm();
    },
    // 函询确认
    confirminDialog(obj) {
      obj.siteNo = this.item.no
      obj.receiveDTO.answerUserType = 1
      obj.receiveDTO.answerCompanyNo = this.item.no
      obj.filedList = JSON.stringify(obj.filedList)
      let data = { ...obj }
      apiLaborServiceCompany.addInquiry(data).then(res => {
        if (res.data.code === 200) {
          this.$message.success("函询成功！");
          this.inByLetDialogShow = false;
          this.$refs.InBylet.clearForm();
        } else {
          this.$message.error(res.data.msg)
          this.$refs.InBylet.closeLoading();
        }
      }).catch(err => {
        if (err.msg) {
          this.$message.error(err.msg)
        } else {
          this.$message.error('函询失败！')
        }
      })
    },
    // 获取函询类型
    getInquiryType() {
      apiLaborServiceCompany.getInquiryType().then(res => {
        if (res.data.code === 200) {
          this.inquiryType = res.data.data
        } else {
          this.$message.error('函询类型获取失败！')
        }
      })
    },
  }
}
</script>

<style scoped>
</style>
